import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Policy } from '../models/policy';

export class StoreUtils<T> {

  private state$: BehaviorSubject<Partial<T>>;
  private _policy: Policy;

  setState(state: Partial<T> = {}) {
    this.state$ = new BehaviorSubject<Partial<T>>(state);
  }

  getState() {
    if (!this.state$) {
      this.setState();
    }
    return this.state$.asObservable();
  }

  getStateValue(): Partial<T> {
    return this.state$.getValue();
  }

  updateState(state: Partial<T>) {
    if (!this.state$) {
      this.setState();
    }
    this.state$.next(state);
  }

  completeState() {
    if (this.state$) {
      this.state$.complete();
    }
  }

  resetState() {
    this.state$ = new BehaviorSubject<Partial<T>>({});
  }

  stateBuilder(
    form: FormGroup,
    state: Partial<T>,
    keys: string[]
  ): Partial<T> {
    const s = { ...state };
    keys.forEach(k => s[k] = form.value[k]);
    return s;
  }

  stateIsComplete(): boolean {
    return this.state$ ? this.state$.isStopped : true;
  }

  clear() {
    this.setState({});
  }

  set policy(policy: Policy) {
    this._policy = policy;
  }

  get policy(): Policy {
    return this._policy;
  }

}
